import type {
  MidiControlChange,
  MidiNote,
  MidiPitchBend,
  MidiTrack,
} from "@midi-fantom-utils/midi-core";
import { DRUM_CHANNEL } from "@midi-fantom-utils/midi-core";
import { cloneInstrument, withChannel } from "./shared.js";

export const isDrumByChannel = (track: MidiTrack): boolean =>
  track.notes.length > 0 && (track.channel === DRUM_CHANNEL || track.instrument.percussion);

/**
 * Соединяет несколько percussion-треков в один на канале 9.
 * Ноты/CC/pitch bends конкатенируются; pitch bends сортируются.
 * Имя объединённого трека = имя источника с наибольшим числом нот.
 * Per-event каналы переписываются на канал 9 (`withChannel`).
 */
export const mergeDrumTracks = (tracks: ReadonlyArray<MidiTrack>): MidiTrack => {
  const largest = tracks.reduce((best, current) =>
    current.notes.length > best.notes.length ? current : best
  );

  const notes: MidiNote[] = [];
  const cc = new Map<number, MidiControlChange[]>();
  const pitchBends: MidiPitchBend[] = [];

  for (const track of tracks) {
    for (const note of track.notes) notes.push(note);
    for (const [number, list] of track.controlChanges) {
      const bucket = cc.get(number) ?? [];
      for (const c of list) bucket.push(c);
      cc.set(number, bucket);
    }
    for (const pb of track.pitchBends) pitchBends.push(pb);
  }

  pitchBends.sort((a, b) => a.ticks - b.ticks);

  return withChannel(
    {
      name: largest.name,
      channel: DRUM_CHANNEL,
      instrument: cloneInstrument(largest.instrument),
      notes,
      controlChanges: cc,
      programChanges: [],
      pitchBends,
      sysex: largest.sysex,
      meta: [],
      unknownMeta: [],
    },
    DRUM_CHANNEL
  );
};